import { FCC } from "@cayo/shared/types/react";
import useScrollResizer from "./hooks";
import { ResizerContainer, ResizingTarget, StyledThumb } from "./styles";

type WidthHandler = (width: number, isFullScreen: boolean) => void;

const Resizer: FCC<{
  onWidthChanged: WidthHandler;
}> = (props) => {
  const { isHovered, resizingTargetRef, ...mouseEvents } = useScrollResizer(props.onWidthChanged);

  return (
    <ResizerContainer>
      <StyledThumb isHovered={isHovered} {...mouseEvents} />
      <ResizingTarget ref={resizingTargetRef}>{props.children}</ResizingTarget>
    </ResizerContainer>
  );
};

export default Resizer;
